import {ReactNode} from "react";
import {css, cx} from "@panda/css";

interface IProps {
    sorted?: boolean;
    href?: string;
    target?: string;
    onLinkClick?: () => void;
    children?: ReactNode;
    className?: string;
}

export const PropertiesTableCell = (props: IProps) => {
    const {href, target, onLinkClick, children, sorted, className} = props;

    return (
        <td {...props} className={cx(tableCell, className, sorted && sortedTableCell)}>
            {href && (
                <a href={href} target={target} onClick={onLinkClick} className={cellLink}>
                    <span className={srOnly}>Przejdź do szczegółów nieruchomości</span>
                </a>
            )}

            <div className={cellContent}>{children}</div>
        </td>
    );
};

const tableCell = css({
    minHeight: "54px",
    border: "0",
    verticalAlign: "middle",
    textAlign: "center",
    padding: "0",
    position: "relative"
});

const sortedTableCell = css({
    background: "var(--colors-background-200)"
});

const cellLink = css({
    position: "absolute",
    inset: "0",
    zIndex: "1",
    textDecoration: "none",
    color: "inherit"
});

const cellContent = css({
    position: "relative",
    zIndex: "2",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    minHeight: "54px",

    "& button, & a": {
        pointerEvents: "auto"
    }
});

const srOnly = css({
    position: "absolute",
    width: "1px",
    height: "1px",
    padding: "0",
    margin: "-1px",
    overflow: "hidden",
    clip: "rect(0, 0, 0, 0)",
    whiteSpace: "nowrap",
    borderWidth: "0"
});

export const cellA = css({
    width: "10%",
    minWidth: "0"
});

export const cellB = css({
    width: "15%",
    minWidth: "0"
});

export const cellC = css({
    width: "20%",
    minWidth: "0"
});

export const cellD = css({
    width: "25%",
    minWidth: "0"
});

export const cellE = css({
    width: "30%",
    minWidth: "0"
});
import {ReactNode} from "react";
import {css, cx} from "@panda/css";

interface IProps {
    sorted?: boolean;
    href?: string;
    target?: string;
    onLinkClick?: () => void;
    children?: ReactNode;
    className?: string;
}

export const PropertiesTableCell = (props: IProps) => {
    const {href, target, onLinkClick, children, sorted, className} = props;

    return (
        <td {...props} className={cx(tableCell, className, sorted && sortedTableCell)}>
            {href && (
                <a href={href} target={target} onClick={onLinkClick} className={cellLink}>
                    <span className={srOnly}>Przejdź do szczegółów nieruchomości</span>
                </a>
            )}

            <div className={cellContent}>{children}</div>
        </td>
    );
};

const tableCell = css({
    minHeight: "54px",
    border: "0",
    verticalAlign: "middle",
    textAlign: "center",
    padding: "0",
    position: "relative"
});

const sortedTableCell = css({
    background: "var(--colors-background-200)"
});

const cellLink = css({
    position: "absolute",
    inset: "0",
    zIndex: "1",
    textDecoration: "none",
    color: "inherit"
});

const cellContent = css({
    position: "relative",
    zIndex: "2",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    minHeight: "54px",

    "& button, & a": {
        pointerEvents: "auto"
    }
});

const srOnly = css({
    position: "absolute",
    width: "1px",
    height: "1px",
    padding: "0",
    margin: "-1px",
    overflow: "hidden",
    clip: "rect(0, 0, 0, 0)",
    whiteSpace: "nowrap",
    borderWidth: "0"
});

export const cellA = css({
    width: "10%",
    minWidth: "0"
});

export const cellB = css({
    width: "15%",
    minWidth: "0"
});

export const cellC = css({
    width: "20%",
    minWidth: "0"
});

export const cellD = css({
    width: "25%",
    minWidth: "0"
});

export const cellE = css({
    width: "30%",
    minWidth: "0"
});
